import React from 'react';

import { ChevronRightIcon } from '@/components/Icons';

import './_styles.scss';

export default function Breadcrumb({ active = false, children, onClick, style = {} }) {
  return (
    <div
      onClick={onClick}
      className="breadcrumb-container cursor-pointer"
      style={{
        ...style,
        color: `${active ? 'var(--text-default)' : 'var(--text-default)'}`,
      }}>
      {children}
    </div>
  );
}

// Breadcrumb.Separator = function BreadCrumbSeparator({ children, style, className, ...rest }) {
export function BreadCrumbSeparator({ children, style, className, ...rest }) {
  return (
    <div style={{ ...style }} className={`breadcrumb-separator ${className}`} {...rest}>
      {children ?? <ChevronRightIcon color="var(--icon-default)" />}
    </div>
  );
}
